/**
* 
*/
<template>
  <div>
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="标题">
        <el-input
          size="small"
          v-model="formInline.InformationLinkTitle"
          placeholder="输入标题"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="分类">
        <el-input
          size="small"
          v-model="formInline.ActivityTypeName"
          placeholder="输入分类"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >查询</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addForm"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <el-table size="small" height="82vh" :data="list" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%">
      <el-table-column align="center" prop="InformationPicURL" label="图片">
        <template slot-scope="scope">
          <el-image
            style="width: 350px; height: 180px" :src="bannerUrl+ scope.row.InformationPicURL" alt="" />
        </template>
      </el-table-column>
    <el-table-column align="center" label="序号"  prop="IDX" width="55">
    </el-table-column>
      <el-table-column align="center" prop="ActivityTypeName" label="分类"></el-table-column>
      <el-table-column align="center" prop="InformationLinkTitle" label="标题"></el-table-column>
      <el-table-column align="center" prop="InformationLinkURL" label="链接"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="text" @click="handleFrozen(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog title="编辑" :visible.sync="editFormVisible" width="60%" @close="closeDialog()">
      <el-form label-width="120px" ref="editForm" :rules="rules" :model="editForm">
        <el-form-item label="分类" prop="ActivityTypeName">
          <el-select v-model="editForm.ActivityTypeName" placeholder="请选择" @change="changeCategory">
            <el-option v-for="item in categoryList" :key="item.ActivityTypeGUID"
              :label="item.ActivityTypeName" :value="item.ActivityTypeGUID"></el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="InformationLinkTitle">
          <el-input v-model="editForm.InformationLinkTitle" placeholder="不超过10个字"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="InformationLinkURL">
          <el-input type="textarea" v-model="editForm.InformationLinkURL"></el-input>
        </el-form-item>
        <el-form-item label="顺序" prop="IDX">
          <el-input type="textarea" v-model="editForm.IDX"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="InformationPicURL">
          <mupload
            :fileList="fileList"
            FilePath="images/Information"
            uploadName="upload"
            :canUpload="true"
            @handleUpload="handleUpload"
            @handleRemove="handleRemoveFile"
          ></mupload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title"
          @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mupload from "@/components/upload.vue";
let flag = true;
export default {
  components: { mupload },
  data () {
    return {
      InformationPic: this.$InformationPic,
      categoryList: [],
      editFormVisible: false,
      loading: false,
      bannerUrl: this.$Url+'Information/',
      list: [],
      fileList:[],
      rules: {
        InformationLinkTitle: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        InformationLinkURL: [{ required: true, message: '链接不能为空', trigger: 'blur' }],
        InformationPicURL: [{ required: true, message: '请上传图片', trigger: 'blur' }],
        IDX: [{ required: true, message: '请排序', trigger: 'blur' }],
        ActivityTypeName: [{ required: true, message: '请选择分类', trigger: 'change' }]
      },
      editForm: {
        InformationLinkTitle: '',
        InformationLinkURL: '',
        ActivityTypeName: '',
        InformationPicURL: '',
        IDX:'1',
      },
      formInline:{
        InformationLinkTitle:"",
        ActivityTypeName:""
      },
      activeIndex: 0
    }
  },
  mounted () {
    this.personInfo = JSON.parse(this.$util.getStore('personInfo'));
    this.getData()
    this.getCategoryList()
  },
  methods: {
    handleUpload(e) {
      console.log(e, 444);
      this.fileList = [e];
      this.editForm.InformationPicURL = e.name;
    },
    handleRemoveFile(e) {
      console.log(e, 30444);
      this.fileList = [];
      this.editForm.InformationPicURL = "";
    },
    changeCategory (e) {
      console.log(e, 83)
      this.editForm.ActivityTypeGUID=e;
    },
    getCategoryList () {
      let sqlCmdName = 'ShopWebApp\\GetActivityTypeList_1_0_1&DBC=r_m';
      let data = {
        CompanyGUID: this.personInfo.CompanyGUID
      }
      this.$api.QueryDataFn(sqlCmdName, data).then(res => {
        let result = res.data;
        console.log(result)
        if (result.OK != 'True') {
          this.$message(result.Message)
        } else if (result.Tag.length == 0) {
          this.$confirm('请先设置分类?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {//待完成

          })
        } else {
          this.categoryList = result.Tag[0].Table;
        }
      })
    },
    addForm () {
      this.editForm = {
        InformationLinkTitle: '',
        InformationLinkURL: '',
        ActivityTypeName: '',
        InformationPicURL: ''
      };
      this.editFormVisible = true
    },
    search(){
      this.getData()
    },
    getData () {
      let {InformationLinkTitle,ActivityTypeName}=this.formInline;
      let data = {
        CompanyGUID: this.personInfo.CompanyGUID,
        InformationLinkTitle,
        ActivityTypeName
      },list=[];

      this.$loading()
      this.$api.QueryDataFn('Web\\GetInformationLinkList_1_0_1&DBC=r_m', data).then(res => {
        let result = res.data;
        this.$loading().close()
        if (result.OK != 'True') {
          this.$message({
            message: result.Message,
            type: 'success'
          });
        } else if (result.Tag.length <= 0) {

        } else {
          list = result.Tag[0].Table;
        }
        this.list=list;
      })
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editForm = row
      this.getNewsDetail(row.InformationLinkGUID)
      this.editFormVisible = true
    },
    //获取信息
    getNewsDetail: function (InformationLinkGUID) {
      let data = {
        InformationLinkGUID
      };
      this.$loading()
      this.$api.QueryDataFn('ShopWebApp\\GetInformationLinkInfo_1_0_1&DBC=r_m', data).then(res => {
        this.$loading().close()
        let result = res.data;
        if (result.OK != 'True') {
          this.$message.error(result.Message)
        } else if (result.Tag.length <= 0) {
          this.$message.error(result.Message)
        } else {
          let editForm = result.Tag[0].Table[0];
          if(editForm.InformationPicURL){
            let obj={
              url:this.bannerUrl+editForm.InformationPicURL,
              name:editForm.InformationPicURL
            }
            this.fileList=[obj]
          }
          this.editForm=editForm
        }

      })
    },
    //显示冻结界面
    handleFrozen: function (index, row) {
      console.log(index, row, 93)
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delete(row.InformationLinkGUID)
      }).catch(() => {

      });
    },

    delete (e) {
      this.$loading();
      this.$api.ExSqlFn('ShopWebApp\\DeleteInformationLink_1_0_1&DBC=w_m', { InformationLinkGUID: e ,
        CompanyGUID:this.personInfo.CompanyGUID}).then((res) => {
        this.$loading().close()
        let result = res.data;
        if (result.OK != 'True') {
          this.$message(result.Message)
        } else {
          this.$message('删除成功');
          this.getData()
        }
      })

    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('valid', valid);
            this.submitTap()
        }
      });

    },
    submitTap: function () {
      let editForm = this.editForm;
      if (editForm.InformationLinkGUID != '') {
        this.releaseNews(editForm.InformationLinkGUID);
      } else {
        this.$api.returnGuid(function (guid) {
          this.releaseNews(guid);
        })
      }
    },
    releaseNews: function (guid) {
      let editForm = this.editForm;
      let data = [{
        InformationLinkGUID: guid,
        InformationLinkTitle: editForm.InformationLinkTitle,
        InformationLinkURL: editForm.InformationLinkURL,
        CompanyGUID: this.personInfo.CompanyGUID,
        InformationPicURL: editForm.InformationPicURL,
        ActivityTypeGUID: editForm.ActivityTypeGUID,
        IDX:editForm.IDX
      }]
      this.$loading()
      this.$api.ExSqlFn('Web\\UpdateInformationLink_1_0_1&DBC=w_m', data).then(res => {
        this.$loading().close()
        let result = res.data;
        if (result.OK != 'True') {
          this.$message(result.Message)
        } else if (result.Tag.length == 0) {
          this.$message('提交资讯信息失败');
        } else {
          this.getData()
          this.editFormVisible = false
        }
      })
    }

  }
}
</script>

<style scoped>
.editor-upload1 {
  width: 350px;
  height: 180px;
  text-align: center;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
}

.upload1-avatar {
  width: 350px;
  height: 180px;
  position: relative;
}

.editor-upload1 .el-upload--text {
  width: 350px;
  height: 180px;
  line-height: 180px;
  display: block;
}

.editor-upload1 .el-upload--picture-card i {
  height: 30px;
}

.absolute {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9;
  font-size: 36px;
}
</style>




// WEBPACK FOOTER //
// src/views/shop/information.vue